// Microcopy do portal: título com verbo, porquê numa linha.
const FEM = /^(caderneta|licen[cç]a|certid[aã]o|declara[cç][aã]o|procura[cç][aã]o|habilita[cç][aã]o|planta|ficha|c[oó]pia|fotoc[oó]pia|escritura|autoriza[cç][aã]o|carta|prova|ata|fatura)/i;
const lower1 = (s) => (s ? s.charAt(0).toLowerCase() + s.slice(1) : s);

export function sendTitle(d) {
  const n = d.client_name || "";
  if (d.state === "problema") return `Envie outra vez: ${lower1(n)}`;
  return `Envie ${FEM.test(n) ? "a" : "o"} ${lower1(n)}`;
}

const WHY = [
  [/^caderneta_predial/, () => "Precisamos dela para confirmar os dados do imóvel."],
  [/^certificado_energetico/, (ctx) => `É obrigatório para avançar com ${ctx}.`],
  [/^licenca_utilizacao/, () => "Sem este documento não conseguimos avançar."],
];

export function sendWhy(d, ctx, fallback) {
  if (d.state === "problema") return "Precisamos que envie outra vez — o ficheiro não ficou legível.";
  const hit = WHY.find(([re]) => re.test(d.key));
  return hit ? hit[1](ctx) : fallback;
}

export const STATE_TXT = {
  review: "Já recebemos — a equipa está a verificar",
  ok: "Documento aceite — não precisa de fazer mais nada",
};
